<template>
    <section>
        <b-message>
            Add challenges to <b>{{gameName}}</b>
        </b-message>

        <button
                class="button is-light btn-margin"
                @click.prevent="cancel()"
        >
            Back to games list
        </button>
        <button
                class="button field is-danger btn-margin"
                @click.prevent="checkedRows = []"
                :disabled="!checkedRows.length"
        >
            <b-icon icon="close"></b-icon>
            <span>Clear selection</span>
        </button>
        <button
                :disabled="!checkedRows.length"
                @click.prevent="associateQuestions(checkedRows)"
                class="button is-success btn-margin"
        >
            Associate the selected challenges
        </button>

        <hr/>

        <div class="field">
            <b-switch v-model="isHideSelected">
                Automatically hide selected challenges
            </b-switch>
        </div>
        <div class="field">
            <strong>{{ checkedRows.length }} selected challenges</strong>
        </div>
        <div class="field">
            <b-input
                    v-model="searchFilter"
                    @input="searchFilterChanged"
                    placeholder="Search for challenges containing this text...?">
            </b-input>
        </div>
        <b-table
                :data="questionsFiltered"
                :columns="columns"
                :checked-rows.sync="checkedRows"
                checkable
                :row-class="getRowClass"
        >
            <template slot="bottom-left">
                <b>Selected challenges</b>: {{ checkedRows.length }}
            </template>
        </b-table>

        <button
                class="button is-light btn-margin"
                @click.prevent="cancel()"
        >
            Back to games list
        </button>
        <button
                class="button field is-danger btn-margin"
                @click.prevent="checkedRows = []"
                :disabled="!checkedRows.length"
        >
            <b-icon icon="close"></b-icon>
            <span>Clear selection</span>
        </button>
        <button
                :disabled="!checkedRows.length"
                @click.prevent="associateQuestions(checkedRows)"
                class="button is-success btn-margin"
        >
            Associate the selected challenges
        </button>

    </section>
</template>

<script>

  import questionService from '../../services/questionsService'
  import displayHelper from '../../helpers/display-helper'

  export default {
    name: 'question-selector',
    data() {
      return {
        gameName: this.$route.params.name,
        gameId: this.$route.params.id,
        pagination: {
          sortBy: 'name'
        },
        isHideSelected: false,
        searchFilter: null,
        checkedRows: [],
        previousSelectedQuestions: [],
        columns: [
          {
            field: 'name',
            label: 'Name',
            sortable: true,
          },
          {
            field: 'question',
            label: 'Question',
            sortable: true,
          },
          {
            field: 'difficulty',
            label: 'Difficulty',
            sortable: true,
          },
          {
            field: 'points',
            label: 'Reward points',
            sortable: true,
          },
          {
            field: 'category',
            label: 'Category',
            sortable: true,
          }
        ],
        questions: [],
        questionsFiltered: [],
      }
    },
    created() {
      this.isLoading = true
      const parent = this
      questionService.getQuestionsForGame(this.$route.params.id)
        .then((data) => {
          this.questions = data.questions
          this.questionsFiltered = data.questions
          this.previousSelectedQuestions = data.checked
          data.questions.map(question => {
            if (this.previousSelectedQuestions.find((previousQuestion) => {
              return previousQuestion.challengeId === question.challengeId
            })) {
              this.checkedRows.push(question)
            }
          })
          this.isLoading = false
        })
        .catch((err) => {
          console.error(err)
          displayHelper.displayError(parent, 'Error fetching questions: ' + err.message)
          this.isLoading = false
        })
    },
    methods: {
      searchFilterChanged(e) {
        if (this.searchFilter && this.searchFilter !== '') {
          let searchLower = this.searchFilter.toLowerCase()
          this.questionsFiltered = this.questions.filter((row, index, arr) => {
            let found = false
            for (let col of this.columns) {
              if (row[col.field] && row[col.field].toString().toLowerCase().indexOf(searchLower) >= 0) {
                found = true
              }
            }
            return found
          })
        } else {
          this.questionsFiltered = this.questions
        }
      },
      getRowClass(row, index) {
        if (this.isHideSelected) {
          if (this.checkedRows.includes(row)) {
            return 'is-hidden'
          } else {
            return 'is-info'
          }
        } else {
          return 'is-info'
        }
      },
      associateQuestions(selectedQuestions) {
        const parent = this
        questionService.updateQuestionsAssociationToGame(this.gameId, selectedQuestions)
          .then(() => {
            this.$router.push({name: 'Games'})
          })
          .catch(err => {
            displayHelper.displayError(parent, 'Error while adding questions to game: ' + err.message)
            console.error(err)
          })
      },
      cancel() {
        this.$router.push({name: 'Games'})
      }
    }
  }

</script>

<style scoped>
    .btn-margin {
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
